<template>
    <div>
        <!-- Alterar Prazo de Entrega -->
        <div class="modal fade" id="alterarPrazoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Data de Entrega</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <template v-if="!lista || !lista.length">

                            <az-empty-state 
                                icon="fas fa-calendar-times"
                                msg="Nenhum procedimento identificado." />

                        </template>

                        <template v-else>

                            <div class="form-row mb-3">
                                <div class="col col-12 col-md-9">
                                    <az-input
                                        type="date"
                                        required
                                        :validate="validate"
                                        v-model="nova_data">
                                        <template v-slot:button-pre>
                                            <div class="input-group-append">
                                                <span class="input-group-text">Nova Data</span>
                                            </div>
                                        </template>
                                    </az-input>

                                    <div class="small text-muted" v-if="nova_data">
                                        {{ $util.getFormatDate(nova_data, 'dddd') }}
                                    </div>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="checkbox-group"
                                        label="Urgente"
                                        :validate="validate"
                                        v-model="urgente" />
                                </div>
                            </div>

                            <table class="table table-hover">
                                <tbody>
                                    <tr v-for="(item, iix) in lista_agrupada" :key="iix">
                                        <td>
                                            <a href="#" class="card-link text-primary">
                                                {{ iix == 'Sem data' ? iix : $util.getFormatDate(iix) }}
                                            </a>
                                        </td>
                                        <td>
                                            {{ $util.getFormatDate(iix, 'dddd') }}
                                        </td>
                                        <td>
                                            {{ item.length }} procedimento(s)
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table class="table table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th width="1%">
                                            <a href="#" class="card-link text-primary" @click.prevent="toggle_selec_all()">
                                                Todos
                                            </a>
                                        </th>
                                        <th>Id</th>
                                        <th>Data</th>
                                        <th>Paciente</th>
                                        <th>Procedimento</th>
                                        <th>Prazo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, iix) in lista" :key="iix">
                                        <td>
                                            <input type="checkbox" v-model="item.selecionado" />
                                        </td>
                                        <td>#{{ item.atendimento_procedimento.id_atendimento }}</td>
                                        <td>{{ item.atendimento_procedimento.atendimento ? $util.getFormatDate(item.atendimento_procedimento.atendimento.dt_inicio) : ''}}</td>
                                        <td>{{ item.atendimento_procedimento.atendimento ? item.atendimento_procedimento.atendimento.paciente.st_nome : '' }}</td>
                                        <td>
                                            {{ item.atendimento_procedimento.procedimento.search }}
                                            <span class="ml-1" v-if="item.atendimento_procedimento.fl_urgente">
                                                <i class="fa fa-exclamation-circle text-danger" aria-hidden="true"></i>
                                                Urgente
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="item.atendimento_procedimento.dt_entrega">
                                                {{ $util.getFormatDate(item.atendimento_procedimento.dt_entrega) }}
                                                <span class="text-muted ml-2">
                                                    {{ $util.getFormatDate(item.atendimento_procedimento.dt_entrega, 'ddd') }}
                                                </span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <pre v-if="false">{{ lista }}</pre>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            lista: [], 
            nova_data: "", 
            validate: false, 
            urgente: false, 
        }
    },

    components: { 
        AzSubmit, 
        AzInput,
        AzEmptyState
    },

    computed: { 
        lista_agrupada: function () { 
            if ( !this.lista ) { 
                return [];
            }

            return _.groupBy(
                this.lista.filter(item => item.selecionado), 
                item => item.atendimento_procedimento.dt_entrega ? item.atendimento_procedimento.dt_entrega.slice(0, 10) : 'Sem data'
            );
        }
    },

    methods: { 
        toggle_selec_all () { 
            let selec = this.lista.find(item => !item.selecionado) ? true : false;

            this.lista.forEach(item => { 
                item.selecionado = selec; 
            });
        },

        abrir_marcacao (id_marcacao) { 

            this.nova_data = "";
            this.urgente = false; 
            this.validate = false; 
            this.lista = [];  
            
            $('#alterarPrazoModal').modal('show');

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'show', 
                parms: { 
                    id: id_marcacao 
                },
                loadTo: (res) => { 
                    if ( res.atendimento && res.atendimento.atendimento_procedimentos ) {

                        let lista = res.atendimento.atendimento_procedimentos.map(item => { 

                            item.atendimento = { 
                                dt_inicio: res.atendimento.dt_inicio, 
                                paciente: res.paciente,
                            }

                            return { 
                                selecionado: true, 
                                id_atendimento_procedimento: item.id_atendimento_procedimento, 
                                atendimento_procedimento: item,
                                id_laudo: item.laudo ? item.laudo.id_laudo : null,
                            }
                        });

                        this.lista = lista; 

                        if ( this.lista.length == 1 ) { 
                            this.urgente = _.get(_.first(this.lista), 'atendimento_procedimento.fl_urgente') ? true : false;
                        }

                    }
                }
            });

        },

        abrir (lista) { 
            this.nova_data = "";
            this.validate = false; 
            
            let lista_selec = _.cloneDeep(lista);

            this.lista = lista_selec.map(item => {
                item.selecionado = true;
                return item;
            });

            $('#alterarPrazoModal').modal('show');
        }, 
        
        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'alterar_data_entrega', 
                dados: { 
                    lista: this.lista.filter(item => item.selecionado).map(item => item.atendimento_procedimento.id_atendimento_procedimento), 
                    nova_data: this.nova_data, 
                    urgente: this.urgente, 
                },
                callback: () => { 
                    $('#alterarPrazoModal').modal('hide');
                    this.$emit('refresh');
                }
            });

        }

    }

}
</script>
